import produce from 'immer'
import { assign, groupBy, stubFalse } from 'lodash'

import { METADATA_TYPES } from '../../constants'
import { buildTreeHierarchy, createTreeSelectOptions } from '../../helpers'
import { flattenTreeStructure } from '../../utils'
import { COMMON_FETCH_INGREDIENTS } from '../action-types'
import { INGREDIENTS_INITIAL_STATE } from '../initial-states'

const ingredientsReducer = (state = INGREDIENTS_INITIAL_STATE, action) => {
  switch (action.type) {
    case COMMON_FETCH_INGREDIENTS.START:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: true,
          error: undefined,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_INGREDIENTS.COMPLETE:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: undefined,
          groupedById: groupBy(
            flattenTreeStructure(action.payload.data.ingredients.results),
            'id',
          ),
          data: buildTreeHierarchy(
            action.payload.data.ingredients.results,
            METADATA_TYPES.INGREDIENTS,
            '',
            '',
            [],
            1,
            action.payload.variables.disableNodes,
          ),
          options: createTreeSelectOptions(
            action.payload.data.ingredients.results,
            'name',
            'id',
            stubFalse,
            ['componentIngredients', 'isCurationEnabled'],
          ),
        }),
      )

    case COMMON_FETCH_INGREDIENTS.FAIL:
      return produce(state, nextState =>
        assign(nextState, {
          isLoading: false,
          error: action.error.message,
          data: undefined,
          options: undefined,
        }),
      )

    case COMMON_FETCH_INGREDIENTS.CLEANUP:
      return { ...INGREDIENTS_INITIAL_STATE }

    default:
      return state
  }
}

export default ingredientsReducer
